export default [
    {
        path: "hourly-subscription-report",
        name: "hourlysubscriptionreport",
        component: () =>
            import(
                /* webpackChunkName: "hourlysubscriptionreport" */ "../pages/hourlySubscriptionReport/HourlySubscriptionReport.vue"
            ),
        meta: {
            title: `Hourly Subscriptions`,
        },
    }
];
